import { ClientView, ClientColumn } from "@common/types/views/clientViews";

export const DefaultClientView: ClientView = {
    type: "client",
    options: {
        selection: false,
        bulkActions: false,
    },
    columns: [
        { id: ClientColumn.NAME },
        { id: ClientColumn.ENTITIES },
        { id: ClientColumn.TEAM },
    ],
    filters: {},
};
